module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "time-box-1"
  }, [_c('span', [_vm._v(_vm._s(_vm.hour > 9 ? parseInt(_vm.hour / 10) : 0))]), _c('span', [_vm._v(_vm._s(_vm.hour % 10))]), _vm._v(" "), _c('span', {
    staticClass: "none-sty"
  }, [_vm._v(":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.minute > 9 ? parseInt(_vm.minute / 10) : 0))]), _c('span', [_vm._v(_vm._s(_vm.minute % 10))]), _vm._v(" "), _c('span', {
    staticClass: "none-sty"
  }, [_vm._v(":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.second > 9 ? parseInt(_vm.second / 10) : 0))]), _c('span', [_vm._v(_vm._s(_vm.second % 10))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5efff458!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/component/timeLabel.vue
// module id = 158
// module chunks = 2